import r from "r-dom";
import { withApollo } from "../../graphql/client";
import ApiKeyManager from "./ApiKeyManager";

export default function (props, context) {
  return function ApiKeyManagerApp() {
    return withApollo(r(ApiKeyManager, props));
  };
}
